<template>
  <div
    class="popup"
    :class="{
      open: open,
    }"
  >
    <div class="popup__container" :class="{ 'popup__container--small': isSmall }">
      <span class="popup__container__msg">{{ msg }}</span>
      <Button
        class="popup__container__btn"
        :backgroundColor="'rgb(0, 0, 0, 1)'"
        :hoverBackgroundColor="'rgb(0, 0, 0, 0.5)'"
        :text="buttonText || getLiteral('popUp.aceptar')"
        borderRadius="5px"
        @click="setClose"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popup',
  data() {
    return {
      msg: '',
      open: false,
      buttonText: null,
      isSmall: false,
    };
  },
  mounted() {
    this.$root.$on('popup', (msg, options = {}) => {
      this.msg = msg;
      this.buttonText = options.buttonText || null;
      this.isSmall = options.isSmall || false;
      this.open = true;
    });
  },
  methods: {
    setClose() {
      this.open = false;
      setTimeout(() => {
        this.msg = '';
        this.buttonText = null;
        this.isSmall = false;
      }, 350);
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 10000;
  opacity: 0;
  width: 100dvw;
  height: 100dvh;
  background-color: rgb(0, 0, 0, 0.75);
  pointer-events: none;
  -webkit-transition: 0.35s ease-in-out opacity;
  -moz-transition: 0.35s ease-in-out opacity;
  -ms-transition: 0.35s ease-in-out opacity;
  -o-transition: 0.35s ease-in-out opacity;
  transition: 0.35s ease-in-out opacity;
  &__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
    max-width: 650px;
    height: auto;
    padding: 50px;
    background-color: white;
    border-radius: 5px;
    gap: 50px;

    &--small {
      width: 20%;
      height: auto;
      padding: 20px;
      gap: 20px;
      max-width: 90vw; 
    }

    &__msg {
      
      text-align: center;
    }
  }
  &.open {
    opacity: 1;
    pointer-events: visible;
    -webkit-transition: 0.35s ease-in-out opacity;
    -moz-transition: 0.35s ease-in-out opacity;
    -ms-transition: 0.35s ease-in-out opacity;
    -o-transition: 0.35s ease-in-out opacity;
    transition: 0.35s ease-in-out opacity;
  }
}
</style>
